import { useState } from 'react';

export const WATCH_COUNTRIES = [
  { value: 'Switzerland', flag: '🇨🇭' },
  { value: 'Japan', flag: '🇯🇵' },
  { value: 'Germany', flag: '🇩🇪' },
  { value: 'France', flag: '🇫🇷' },
  { value: 'United States', flag: '🇺🇸' },
  { value: 'United Kingdom', flag: '🇬🇧' },
  { value: 'Italy', flag: '🇮🇹' },
  { value: 'Denmark', flag: '🇩🇰' },
  { value: 'Sweden', flag: '🇸🇪' },
  { value: 'Finland', flag: '🇫🇮' },
  { value: 'Norway', flag: '🇳🇴' },
  { value: 'Russia', flag: '🇷🇺' },
  { value: 'China', flag: '🇨🇳' },
  { value: 'Canada', flag: '🇨🇦' },
  { value: 'Australia', flag: '🇦🇺' },
  { value: 'Hong Kong', flag: '🇭🇰' },
  { value: 'Singapore', flag: '🇸🇬' },
  { value: 'Spain', flag: '🇪🇸' },
  { value: 'Netherlands', flag: '🇳🇱' },
  { value: 'Austria', flag: '🇦🇹' },
  { value: 'Czech Republic', flag: '🇨🇿' },
  { value: 'Poland', flag: '🇵🇱' },
  { value: 'Portugal', flag: '🇵🇹' },
  { value: 'South Korea', flag: '🇰🇷' },
  { value: 'Taiwan', flag: '🇹🇼' },
  { value: 'India', flag: '🇮🇳' },
  { value: 'Israel', flag: '🇮🇱' },
  { value: 'Belgium', flag: '🇧🇪' },
  { value: 'South Africa', flag: '🇿🇦' },
  { value: 'Nigeria', flag: '🇳🇬' },
  { value: 'Kenya', flag: '🇰🇪' },
  { value: 'Brazil', flag: '🇧🇷' },
  { value: 'Mexico', flag: '🇲🇽' },
  { value: 'Puerto Rico', flag: '🇵🇷' },
  { value: 'Ireland', flag: '🇮🇪' },
  { value: 'Greece', flag: '🇬🇷' },
  { value: 'Hungary', flag: '🇭🇺' },
  { value: 'Romania', flag: '🇷🇴' },
  { value: 'Lithuania', flag: '🇱🇹' },
  { value: 'Thailand', flag: '🇹🇭' },
  { value: 'Philippines', flag: '🇵🇭' },
  { value: 'Indonesia', flag: '🇮🇩' },
  { value: 'Vietnam', flag: '🇻🇳' },
  { value: 'New Zealand', flag: '🇳🇿' },
  { value: 'UAE', flag: '🇦🇪' },
  { value: 'Lebanon', flag: '🇱🇧' },
];

export const COUNTRY_FLAGS: Record<string, string> = Object.fromEntries(
  WATCH_COUNTRIES.flatMap(({ value, flag }) => [
    [value.toLowerCase(), flag],
    ...(value === 'United States' ? [['usa', flag]] : []),
    ...(value === 'United Kingdom' ? [['uk', flag], ['england', flag]] : []),
  ])
);

export function getCountryDisplay(country?: string): string {
  if (!country) return '';
  const flag = COUNTRY_FLAGS[country.toLowerCase()] ?? '';
  return flag ? `${flag} ${country}` : country;
}

interface CountrySelectProps {
  value: string;
  onChange: (v: string) => void;
  label?: string;
}

export function CountrySelect({ value, onChange, label = 'Country of Origin' }: CountrySelectProps) {
  const isKnown = !value || WATCH_COUNTRIES.some(c => c.value === value);
  const [customMode, setCustomMode] = useState(!isKnown);

  if (customMode) {
    return (
      <div>
        <label className='block text-sm font-medium text-gray-700 mb-1'>{label}</label>
        <input
          type='text'
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder='Enter country name...'
          autoFocus
          className='w-full border border-amber-300 bg-amber-50 rounded-lg px-3 py-2 focus:ring-2 focus:ring-brand-500 focus:border-brand-500'
        />
        <button
          type='button'
          onClick={() => { setCustomMode(false); onChange(''); }}
          className='text-xs text-amber-700 hover:text-amber-900 underline mt-1'
        >
          Back to dropdown
        </button>
      </div>
    );
  }

  return (
    <div>
      <label className='block text-sm font-medium text-gray-700 mb-1'>{label}</label>
      <select
        value={value}
        onChange={(e) => {
          if (e.target.value === '__other__') {
            setCustomMode(true);
            onChange('');
          } else {
            onChange(e.target.value);
          }
        }}
        className='w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-brand-500 focus:border-brand-500'
      >
        <option value=''>Select country...</option>
        {WATCH_COUNTRIES.map(({ value: v, flag }) => (
          <option key={v} value={v}>{flag} {v}</option>
        ))}
        <option value='__other__'>-- Other --</option>
      </select>
    </div>
  );
}
